import { StatusIcon } from "../../match/StatusIcon"
import { Status } from "../../models"
import { BeachTickerMatchDay, BeachTickerMatchSeries } from "../model"
import { BeachTickerMatchStatesByUuid } from "../reducer"
import "./BeachMatchSeriesView.scss"

interface Props {
  matchSeries: BeachTickerMatchSeries
  matchStatesByUuid: BeachTickerMatchStatesByUuid
  matchDay: BeachTickerMatchDay
}

export const BeachMatchSeriesView = (props: Props) => {

  const {
    matchSeries,
    matchStatesByUuid,
    matchDay
  } = props

  const started = matchSeries.matches.find(id => matchDay.matches.find(m => m.id === id) && matchStatesByUuid[id]?.started)

  return <div className="BeachMatchSeries">{matchSeries.name} {started && <StatusIcon status={Status.LIVE}></StatusIcon>}</div>
}
